import {dateTime} from "services/date";
import {Spotlight} from "types/Spotlight";
import {RRule} from "rrule";

/**
 * Transform the given spotlight by deserializing object properties
 *
 * @internal
 * @param spotlight
 */
export default function deserializeSpotlight(spotlight: any): Spotlight {
  spotlight.enable_at = dateTime(spotlight.enable_at)
  spotlight.disable_at = dateTime(spotlight.disable_at)
  spotlight.recurrence = spotlight.recurrence ? RRule.fromString(spotlight.recurrence) : null

  spotlight.enabled_at = dateTime(spotlight.enabled_at)
  spotlight.created_at = dateTime(spotlight.created_at)
  spotlight.updated_at = dateTime(spotlight.updated_at)

  return spotlight;
}